const basic = `.container {
    position: relative;
    background-color: black;

}`

export default basic